import React, { useState, useEffect } from 'react';

const MaintenanceMessage = () => {
    
    const calculateRemainingTime = () => {
        // Obtiene la fecha y hora actual en UTC
        const now = new Date();

        // Define la hora de finalización del mantenimiento en UTC (06:00 GMT-3 = 09:00 UTC)
        const maintenanceEnd = new Date();
        maintenanceEnd.setUTCHours(8, 20, 0, 0);

        // Calcula la diferencia en milisegundos
        const diff = maintenanceEnd.getTime() - now.getTime();

        if (diff <= 0) {
            return { hours: 0, minutes: 0, seconds: 0, isTimeUp: true };
        }

        // Convierte la diferencia de milisegundos a horas, minutos y segundos
        let totalSeconds = Math.floor(diff / 1000);
        let hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        let minutes = Math.floor(totalSeconds / 60);
        let seconds = totalSeconds % 60;

        return { hours, minutes, seconds, isTimeUp: false };
    };

    const [timeLeft, setTimeLeft] = useState(calculateRemainingTime());

    useEffect(() => {
        const timer = setInterval(() => {
            const newTimeLeft = calculateRemainingTime();
            if (newTimeLeft.isTimeUp) {
                clearInterval(timer);
                // Cuando el tiempo se acaba, recarga la página para verificar el nuevo estado
                window.location.reload();
            }
            setTimeLeft(newTimeLeft);
        }, 1000);

        // Limpia el intervalo cuando el componente se desmonta
        return () => clearInterval(timer);
    }, []);

    // Función para formatear el tiempo y añadir un cero a la izquierda si es necesario
    const formatTime = (time) => String(time).padStart(2, '0');

    return (
        <div className="text-center">
            {/* --- Mensagem em Português --- */}
            <div style={{ marginBottom: '2rem' }}>
                <h3 className="mb-2">🚧 Manutenção Programada em Andamento 🚧</h3>
                <p>
                    Informamos que nosso sistema está passando por uma manutenção programada, que ocorre entre as <strong>04:30 e 05:20 (GMT-3)</strong>.
                </p>
                <p>
                    Agradecemos a sua paciência e pedimos desculpas por qualquer inconveniente.
                </p>
                <p className="font-weight-bold">
                    Tempo estimado para a reativação do serviço:
                </p>
            </div>

            {/* --- Mensaje en Español --- */}
            <div style={{ marginBottom: '2rem' }}>
                <h3 className="mb-2">🚧 Mantenimiento Programado en Curso 🚧</h3>
                <p>
                    Te informamos que nuestro sistema está en mantenimiento programado, que se realiza entre las <strong>04:30 y 05:20 hs. (GMT-3)</strong>.
                </p>
                <p>
                    Agradecemos tu paciencia y te pedimos disculpas por las molestias ocasionadas.
                </p>
                <p className="font-weight-bold">
                    Tiempo estimado para la reactivación del servicio:
                </p>
            </div>

            {/* --- Contador --- */}
            <div className="timer-container" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#007bff' }}>
                <span>{formatTime(timeLeft.hours)}</span>:
                <span>{formatTime(timeLeft.minutes)}</span>:
                <span>{formatTime(timeLeft.seconds)}</span>
            </div>
        </div>
    );
};

export default MaintenanceMessage;
